/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { css } from '@emotion/react';
import tw from 'twin.macro';
import { QuestionHint } from 'components/shared/QuestionHint';


const customTooltipCss = css`
  ${tw`font-size[1rem]`}
`;

interface SearchInputFieldProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInputField = ({
  searchTerm,
  onSearchChange,
  onKeyDown,
}: SearchInputFieldProps) => {
  return (
    <div tw="flex flex-col">
      <label tw="flex items-center gap-x-3">
        <span tw="text-15">Search</span>
        <span tw="flex [svg]:(h-[1.8rem] w-[1.8rem])">
          <QuestionHint
            type="information"
            align="bottomLeft"
            action="hover"
            customStyle={customTooltipCss}
            text="Search across API name, file name, content type, and more"
            hideCloseButton
          />
        </span>
      </label>
      <div tw="min-w-[20rem]">
        <input
          tw="(w-full pr-11 border-width[2px] right[-2px] mb-0 placeholder:text-14)!"
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => {
            onSearchChange(e.target.value);
          }}
          onKeyDown={onKeyDown}
        />
      </div>
    </div>
  );
};

